// Components
import Button from 'components/General/Button/Button';
import OnboardingCard from 'components/Onboarding/OnboardingCard/OnboardingCard';
import SelectBox, { SchoolsSelectBox } from 'components/General/SelectBox/SelectBox';
import TextField from 'components/General/TextField/TextField';

// Date picker
import { DatePicker } from 'react-rainbow-components';

// Logic
import { useLogic } from './SchoolInfo.logic';

// Grid system
import { Col, Row } from 'react-grid-system';

// React hook form
import { Controller } from 'react-hook-form';

// Assets
import { countries } from 'assets/files/countries';
import { useNavigate, useParams } from 'react-router';
import { STUDENT_DASHBOARD } from 'routes/CONSTANTS';

const SchoolInfoGMAT = () => {
  const {
    options,
    errors,
    control,
    takenSat,
    onboardingState,
    onSubmit,
    setValue,
    getValues,
    isLoadingAdminPostInfo,
    isLoadingFinishOnboarding,
    isLoadingAdminFinishOnboarding,
    previousPage,
    dispatch
  } = useLogic();
  const navigate = useNavigate();
  const { userId, className } = useParams();

  return (
    <Row>
      <Col
        md={6}
        offset={{ md: 3 }}
      >
        <OnboardingCard>
          <h2>Tell us about your school</h2>
          <form onSubmit={onSubmit}>
            <Controller
              control={control}
              name="country"
              rules={{
                required: {
                  value: true,
                  message: 'This field is required'
                }
              }}
              render={({ fieldState: { error }, field: { onChange, value } }) => (
                <SelectBox
                  options={countries}
                  label="Country"
                  placeholder="United Arab Emirates"
                  error={error?.message}
                  onChange={onChange}
                  value={value}
                />
              )}
            />
            <Controller
              control={control}
              name="schoolName"
              rules={{
                required: {
                  value: true,
                  message: 'This field is required'
                }
              }}
              render={({ fieldState: { error }, field: { onChange, value } }) => (
                <SchoolsSelectBox
                  addSchool
                  label="School name"
                  placeholder="School name"
                  error={error?.message}
                  onChange={onChange}
                  value={value}
                />
              )}
            />
            <Controller
              control={control}
              name="graduationYear"
              rules={{
                required: {
                  value: true,
                  message: 'This field is required'
                }
              }}
              render={() => (
                <div className="rainbow-m-around_small">
                  <DatePicker
                    placeholder="YYYY-MM-DD"
                    labelAlignment="left"
                    className="date-picker"
                    label="Graduation year"
                    onChange={(value) => setValue('graduationYear', value)}
                    error={errors.graduationYear?.message}
                    icon={<></>}
                    value={getValues().graduationYear}
                  />
                </div>
              )}
            />
            <Controller
              control={control}
              name="takenCourse"
              rules={{
                required: {
                  value: true,
                  message: 'This field is required'
                }
              }}
              render={({ fieldState: { error }, field: { onChange } }) => (
                <SelectBox
                  options={options}
                  label={`Have you previously taken the ${className || onboardingState.plan.course}?`}
                  placeholder="Select..."
                  error={error?.message}
                  onChange={onChange}
                />
              )}
            />
            { takenSat && (
            <>
              <Controller
                control={control}
                name="scores.totalScore"
                rules={{
                  required: {
                    value: takenSat,
                    message: 'This field is required'
                  },
                  min: {
                    value: 200,
                    message: 'Score cannot be below 200'
                  },
                  max: {
                    value: 800,
                    message: 'Score cannot be above 800'
                  }
                }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    color="light-gray"
                    variant="rounded"
                    onChange={onChange}
                    placeholder="400 - 800"
                    id="total-score"
                    label="Total score"
                    type="number"
                    error={errors?.scores?.totalScore?.message}
                    value={value || ''}
                  />
                )}
              />
              <Controller
                control={control}
                name="scores.QuantitativeScore"
                rules={{
                  required: {
                    value: takenSat,
                    message: 'This field is required'
                  },
                  min: {
                    value: 0,
                    message: 'Score cannot be below 0'
                  },
                  max: {
                    value: 60,
                    message: 'Score cannot be above 60'
                  }
                }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    color="light-gray"
                    placeholder="0 - 60"
                    variant="rounded"
                    label="Quantitative score"
                    id="Quantitative-score"
                    type="number"
                    onChange={onChange}
                    error={errors?.scores?.QuantitativeScore?.message}
                    value={value || ''}
                  />
                )}
              />
              <Controller
                control={control}
                name="scores.verbalScore"
                rules={{
                  required: {
                    value: takenSat,
                    message: 'This field is required'
                  },
                  min: {
                    value: 0,
                    message: 'Score cannot be below 0'
                  },
                  max: {
                    value: 60,
                    message: 'Score cannot be above 60'
                  }
                }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    color="light-gray"
                    onChange={onChange}
                    error={errors?.scores?.verbalScore?.message}
                    id="verbal-score"
                    type="number"
                    placeholder="0 - 60"
                    label="Verbal score"
                    variant="rounded"
                    value={value || ''}
                  />
                )}
              />
            </>
            )}
            <div className="button-container mb-1">
              <Button
                color="primary"
                type="submit"
                isLoading={isLoadingFinishOnboarding || isLoadingAdminFinishOnboarding || isLoadingAdminPostInfo}
              >
                Next
              </Button>
              <div className="skip-container mb-3">
                <div className="back-container mb-2 mt-1">
                  <Button
                    color="white"
                    onClick={() => dispatch(previousPage())}
                  >
                    Back

                  </Button>
                </div>
              </div>
              {!userId && (
                <h3>
                  <a
                    href="#"
                    onClick={() => navigate(STUDENT_DASHBOARD)}
                  >
                    Skip
                  </a>

                </h3>
              )}
            </div>
          </form>
        </OnboardingCard>
      </Col>
    </Row>
  );
};
export default SchoolInfoGMAT;
